import * as React from "react";
import { StaticImageData } from "next/image";

import { LinkButton } from "@stadium/shared/src/components/shared/button";
import Multimedia from "@stadium/shared/src/components/shared/multimedia";

import { BENTO_GRID_DEFAULTS, BG_03 } from "@stadium/shared/src/helpers/plasmic/static-slices";

import styles from "./main.module.scss";

export interface BG03CardItem {
  cardIcon?: string | StaticImageData;
  cardIconAlt?: string;
  cardTitle?: string;
  cardDescription?: string;
  cardLinkText?: string;
  cardLinkUrl?: string;
}

export interface BG03Props {
  bg03Heading?: string;
  bg03Card1?: BG03CardItem;
  bg03Card2?: BG03CardItem;
  bg03Card3?: BG03CardItem;
  bg03Card4?: BG03CardItem;
  className?: string;
}

const FeatureCard: React.FC<Readonly<{ card: BG03CardItem }>> = ({ card }) => (
  <div className={styles.featureCard}>
    {card.cardIcon && (
      <div className={styles.iconWrapper}>
        <Multimedia
          type="image"
          src={card.cardIcon}
          alt={card.cardIconAlt || ""}
          className={styles.cardIcon}
        />
      </div>
    )}
    <h3 className={styles.cardTitle}>{card.cardTitle}</h3>
    <p className={styles.cardDescription}>{card.cardDescription}</p>
    {card.cardLinkText && card.cardLinkUrl && (
      <div className={styles.cardLinkWrapper}>
        <LinkButton styleType="no-style" href={card.cardLinkUrl} className={styles.cardLink}>
          {card.cardLinkText}
        </LinkButton>
      </div>
    )}
  </div>
);

const BG03: React.FC<Readonly<BG03Props>> = ({
  bg03Heading = BENTO_GRID_DEFAULTS[BG_03].heading,
  bg03Card1 = BENTO_GRID_DEFAULTS[BG_03].cards[0],
  bg03Card2 = BENTO_GRID_DEFAULTS[BG_03].cards[1],
  bg03Card3 = BENTO_GRID_DEFAULTS[BG_03].cards[2],
  bg03Card4 = BENTO_GRID_DEFAULTS[BG_03].cards[3],
  className,
}) => {
  const cards = [bg03Card1, bg03Card2, bg03Card3, bg03Card4];

  return (
    <section className={`${styles.sectionWrapper} ${className || ""}`}>
      <div className={styles.divWrapper}>
        <h2 className={styles.heading}>{bg03Heading}</h2>
        <div className={styles.cardsGrid}>
          {cards.map((card, index) => (
            <FeatureCard key={card.cardTitle || index} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BG03;
